import { render, staticRenderFns } from "./batchupgrade.vue?vue&type=template&id=697b0364&scoped=true"
import script from "./batchupgrade.vue?vue&type=script&lang=js"
export * from "./batchupgrade.vue?vue&type=script&lang=js"
import style0 from "./batchupgrade.vue?vue&type=style&index=0&id=697b0364&prod&lang=scss"
import style1 from "./batchupgrade.vue?vue&type=style&index=1&id=697b0364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b0364",
  null
  
)

export default component.exports